import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Ringcentral from './ringcentral-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Ringcentral {...validProps} />;
}
SvgComponent.iconName = 'ringcentral';

export const RingcentralIcon = svgIconWrapper(SvgComponent);
